import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const SIDE_IMG = "https://images.unsplash.com/photo-1656247203824-3d6f99461ba4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Register() {
  const { registerEmail } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await registerEmail(data.email, data.password, data.name);
      toast.success("Welcome to Abbot Asia.");
      navigate("/portal");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-ivory">
      <div className="relative hidden md:block">
        <img src={SIDE_IMG} alt="Bali rice fields" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-jade/35" />
        <div className="relative z-10 h-full flex flex-col justify-between p-14">
          <Link to="/" className="font-serif text-3xl text-ivory">Abbot <span className="italic text-copper">Asia</span></Link>
          <div>
            <p className="eyebrow text-copper">Begin</p>
            <p className="font-serif text-ivory text-4xl mt-3 leading-tight max-w-md italic">"Thoughtful journeys. Meaningful connections."</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-20 md:py-0">
        <div className="w-full max-w-md">
          <p className="eyebrow">Create an account</p>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl text-jade font-light">Begin your portal.</h1>
          <p className="mt-4 text-ink/70 text-[15px] font-light">Once your enquiry is confirmed, your itinerary will appear here.</p>

          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <label className="eyebrow">Full name</label>
              <input data-testid="register-name" required className="input-line mt-3" value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} />
            </div>
            <div>
              <label className="eyebrow">Email</label>
              <input data-testid="register-email" type="email" required className="input-line mt-3" value={data.email} onChange={(e) => setData({ ...data, email: e.target.value })} />
            </div>
            <div>
              <label className="eyebrow">Password</label>
              <input data-testid="register-password" type="password" minLength={8} required className="input-line mt-3" value={data.password} onChange={(e) => setData({ ...data, password: e.target.value })} />
              <p className="text-[11px] text-ink/50 mt-2">Minimum eight characters.</p>
            </div>
            <button data-testid="register-submit" disabled={busy} type="submit" className="btn-primary w-full disabled:opacity-50">
              {busy ? "Creating account…" : "Create Account"}
            </button>
          </form>

          <p className="mt-8 text-[13px] text-ink/65">
            Already a traveller? <Link to="/login" data-testid="link-login" className="text-jade underline-offset-4 hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
